import React, { useState } from 'react';
import { makeStyles, Modal } from '@material-ui/core';
import useStyles from '../KeyTypes/CommonStyle';
import DateTime, { KeyTypeEnum } from '../DateTime/DateTime';
import UserSelection from '../UserSelection/UserSelection';

const useMakeStyles = makeStyles((theme) => ({
	modal: {
		'&:focus': {
			outline: 'none',
		},
		'&:active': {
			outline: 'none',
		},
		background: '#1a23293b !important',
		zIndex: '30000 !important',
	},
	modalPaper: {
		position: 'absolute',
		[theme.breakpoints.up('xs')]: {
			height: 239,
			width: 294,
		},
		[theme.breakpoints.up('md')]: {
			width: '90%',
			height: '80%',
		},
		backgroundColor: theme.palette.background.paper,
		borderTop: '5px solid #0050F2',
		boxShadow: theme.shadows[5],
		border: 'none',
		padding: '0px',
		textAlign: 'center',
		borderRadius: '5px',
		outline: 'none',
		display: 'flex',
		justifyContent: 'flex-start',
		alignItems: 'center',
		flexDirection: 'column',
	},
	modalHeader: {
		textAlign: 'center',
		border: '0px',
		width: '100%',
		borderBottom: '1px solid #DDE3ED',
		padding: '15px 0',
		[theme.breakpoints.up('xs')]: {
			// marginTop: '15px',
			marginBottom: '15px',
		},
		[theme.breakpoints.up('md')]: {
			// marginTop: '20px',
			marginBottom: '20px',
		},
	},
	modalBody: {
		position: 'relative',
		padding: '0px 25px',
		textAlign: 'center',
		width: '75%',
		// height: 'calc(100% - 155px)',
	},
	showErrorMessage: {
		width: '100%',
		padding: '5px 0px',
		font: 'var(--zui-typography-body)',
		fontSize: '14px',
		lineHeight: '20px',
		textAlign: 'center',

		color: '#828D9E',
	},
	messagebody: {
		width: 'inherit',
		position: 'relative',
		display: 'block',
		[theme.breakpoints.up('xs')]: {
			margin: '15px 0px',
		},
		[theme.breakpoints.up('md')]: {
			margin: '30px 0px',
		},
	},
	modalFooter: {
		marginTop: 'auto',
		borderTop: '1px solid #DDE3ED',
		alignSelf: 'center',
		display: 'flex',
		width: '100%',
		textAlign: 'center',
	},
	keyFormContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		gap: '2rem',
	},
	keyFormChildren: {
		display: 'flex',
		alignItems: 'center',
		gap: '0.5rem',
		width: '100%',
		flexDirection: 'column',
	},
	keyFormChildrenAutocomplete: {
		display: 'block',
		width: '100%',
	},
}));

function getModalStyle() {
	const top = 50;
	const left = 50;

	return {
		top: `${top}%`,
		left: `${left}%`,
		transform: `translate(-${top}%, -${left}%)`,
	};
}

export default function KeyOnBehalfModal({
	openState,
	clickClose,
	selectedMachines,
	keyTypeDate,
	onGenerateKey,
}) {
	const classes = useMakeStyles();
	const commonClasses = useStyles();
	const [modalStyle] = useState(getModalStyle);

	const [onBehalfData, setOnBehalfData] = useState({
		user: { id: '', email: '' },
		dateTime: '',
		icCodes: [],
	});
	const isFormComplete =
		onBehalfData.user.id &&
		onBehalfData.dateTime &&
		onBehalfData.icCodes.length > 0;

	React.useEffect(() => {
		if (openState) {
			setOnBehalfData((prev) => ({
				...prev,
				icCodes: selectedMachines.map((m) => m.icCode),
			}));
		}
		// set date if "FOUREIGHTWEEKS" keyType
		if (keyTypeDate === KeyTypeEnum[2] && !onBehalfData.dateTime) {
			const d = new Date();
			setOnBehalfData((prev) => ({ ...prev, dateTime: d }));
		}
	}, [openState, selectedMachines, keyTypeDate, onBehalfData.dateTime]);

	const handleDateChange = (value) => {
		setOnBehalfData((prev) => ({
			...prev,
			dateTime: value,
		}));
	};

	const handleClose = () => {
		clickClose();
		setOnBehalfData({
			user: { id: '', email: '' },
			dateTime: '',
			icCodes: [],
		});
	};

	const handleSendData = () => {
    if (onGenerateKey) {
        onGenerateKey(onBehalfData);
    }

    handleClose();
	};
	return (
		<>
			<Modal
				disableAutoFocus={true}
				className={classes.modal}
				open={openState}
				onClose={handleClose}
				aria-labelledby="simple-modal-title"
				aria-describedby="simple-modal-description"
			>
				<div style={modalStyle} className={classes.modalPaper}>
					<div
						className={classes.modalHeader}
						style={{
							display: 'flex',
							flexDirection: 'column',
							alignItems: 'center',
						}}
					>
						<p> Generate key for following machines:</p>
						<div style={{ display: 'flex', gap: '3px', flexWrap: 'wrap' }}>
							|
							{selectedMachines.map((machine, index) => (
								<div key={index}>
									<b>{machine.name}</b> |
								</div>
							))}
						</div>
					</div>
					<div className={classes.modalBody}>
						<form action="" type="submit" className={classes.keyFormContainer}>
							<div className={classes.keyFormChildrenAutocomplete}>
								<label>User:</label>
								<UserSelection
									onUserSelect={(user) =>
										setOnBehalfData((prev) => ({ ...prev, user }))
									}
								/>
							</div>
							<div className={classes.keyFormChildren}>
								<label>Date:</label>
								<DateTime
									keyType={keyTypeDate}
									selectedDateInput={onBehalfData.dateTime}
									onDateChange={handleDateChange}
								/>
							</div>
							<div className={classes.keyFormChildren}>
								<label>IC Codes of selected machines:</label>
								<div style={{ display: 'flex', gap: '3px', flexWrap: 'wrap' }}>
									|
									{onBehalfData.icCodes.map((code, index) => (
										<div key={index}>
											<b>{code}</b> |
										</div>
									))}
								</div>
							</div>
						</form>
					</div>
					<div className={`${classes.modalFooter}`}>
						<button
							type="button"
							className="btn-modal modalbtn"
							onClick={handleClose}
						>
							Cancel
						</button>
						<button
							disabled={!isFormComplete}
							type="button"
							className={`${commonClasses.btnSubmit} ${
								!isFormComplete && commonClasses.btnDisabled
							} btn-modal-submit`}
							onClick={handleSendData}
						>
							{keyTypeDate === 'ONEDAY'
								? 'Generate Key'
								: keyTypeDate === 'FOUREIGHTWEEKS'
								? 'Download'
								: ''}
						</button>
					</div>
				</div>
			</Modal>
		</>
	);
}
